import { useState, useEffect } from 'react';

const isNullOrEmpty = (s) => (s === null || s === undefined || s.trim() === '');
const tryParseValue = (str) => {
	try {
		return { ok: true, output: JSON.parse(str) };

	} catch {
		return { ok: false, output: null };
	}
};
export function useLocalStorage(key) {
	const [value, setValue] = useState(null);
	const browserHasLocalStorageAvailable = typeof window !== 'undefined' && window.localStorage !== undefined;
	const storage = browserHasLocalStorageAvailable ? window.localStorage : null;

	useEffect(() => {
		if (!browserHasLocalStorageAvailable)
			return;
		if (isNullOrEmpty(key))
			return;
		const storageValue = storage.getItem(key);
		if (isNullOrEmpty(storageValue))
			return;
		const parsedValue = tryParseValue(storageValue);
		setValue(parsedValue.ok ? parsedValue.output : storageValue);
	}, [key, storage, browserHasLocalStorageAvailable]);

	useEffect(() => {

		if (!browserHasLocalStorageAvailable)
			return;

		if (value === null || value === undefined) {
			storage.removeItem(key);
			return;
		}
		const storageValue = storage.getItem(value);
		const requireSerialization = typeof value === typeof {} || typeof value === typeof [];
		const serializedValue = requireSerialization ? JSON.stringify(value) : null;
		if ('' + value === storageValue || serializedValue === storageValue)
			return;

		window.localStorage.setItem(key, requireSerialization ? serializedValue : value);

	}, [value, storage, key, browserHasLocalStorageAvailable]);

	return [value, setValue];
}